import { defineAction } from "redux-define";
import {
    SUCCESS,
    TheApp,
} from "../../constants/stateConstants";

export const avocados = defineAction("avocados", [SUCCESS], TheApp);
export const CREATE = defineAction("CREATE", [SUCCESS], avocados);
